import { render } from "./TopNavigation.vue?vue&type=template&id=2635ea9a"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"

import "./TopNavigation.vue?vue&type=style&index=0&id=2635ea9a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__